module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-wrap"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('img'), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac30d790!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/test/components/common/boxWrap/index.vue
// module id = 2073
// module chunks = 2